module.exports = __webpack_public_path__ + "static/media/skull.c6b08fbc.gif";